import React, { useState } from 'react';
import { useTranslation } from '../../../hooks/useTranslation';

export default function Approach() {
  const { t } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
        </svg>
      ),
      title: t('results.freedom.healthy_sleep'),
      description: t('results.freedom.sleep_description'),
      gradient: 'from-green-400 to-green-600'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
        </svg>
      ),
      title: t('results.freedom.energy'),
      description: t('results.freedom.energy_description'),
      gradient: 'from-blue-400 to-blue-600'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
      ),
      title: t('results.freedom.confidence'),
      description: t('results.freedom.confidence_description'),
      gradient: 'from-purple-400 to-purple-600'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
        </svg>
      ),
      title: t('results.freedom.harmony'),
      description: t('results.freedom.harmony_description'),
      gradient: 'from-rose-400 to-rose-600'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"></path>
        </svg>
      ),
      title: t('results.freedom.clarity'),
      description: t('results.freedom.clarity_description'),
      gradient: 'from-yellow-400 to-yellow-600'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
        </svg>
      ),
      title: t('results.freedom.purpose'),
      description: t('results.freedom.purpose_description'),
      gradient: 'from-indigo-400 to-indigo-600'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };
  return (
    <section className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-6 text-white">{t('approach.title')}</h2>
        </div>
        
        {/* 3 карточки: Подход, Философия, Ценности */}
        <div className="grid lg:grid-cols-3 gap-8">
          {/* Карточка 1: Мой подход */}
          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-white/20 hover:bg-white/20 transition-all duration-300 group h-full">
            <div className="text-center h-full flex flex-col">
              <div className="w-16 h-16 bg-rose-300/20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-rose-300/30 transition-colors duration-300">
                <svg className="w-8 h-8 text-rose-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">{t('approach.my_approach')}</h3>
              <div className="flex items-center justify-center gap-3 mb-6">
                <div className="w-4 h-4 bg-rose-300 rounded-full"></div>
                <span className="text-lg font-semibold text-white">{t('approach.heart')}</span>
                <span className="text-gray-300">+</span>
                <div className="w-4 h-4 bg-white rounded-full"></div>
                <span className="text-lg font-semibold text-white">{t('approach.strategy')}</span>
              </div>
              <p className="text-gray-200 leading-relaxed flex-grow">
                {t('approach.description')}
              </p>
            </div>
          </div>

          {/* Карточка 2: Философия */}
          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-white/20 hover:bg-white/20 transition-all duration-300 group h-full">
            <div className="text-center h-full flex flex-col">
              <div className="w-16 h-16 bg-blue-300/20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-blue-300/30 transition-colors duration-300">
                <svg className="w-8 h-8 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white mb-6">{t('approach.philosophy')}</h3>
              <div className="flex-grow flex items-center justify-center">
                <div className="text-center">
                  <p className="text-gray-200 leading-relaxed text-lg">
                    {t('approach.philosophy_desc')}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Карточка 3: Ценности */}
          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-white/20 hover:bg-white/20 transition-all duration-300 group h-full">
            <div className="text-center h-full flex flex-col">
              <div className="w-16 h-16 bg-green-300/20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-green-300/30 transition-colors duration-300">
                <svg className="w-8 h-8 text-green-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white mb-6">{t('approach.values')}</h3>
              <div className="flex-grow flex items-center justify-center">
                <div className="text-center">
                  <p className="text-gray-200 leading-relaxed text-lg">
                    {t('approach.values_desc')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Новый раздел "Результат — это свобода" */}
        <div className="mt-16">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-6">
              {t('results.freedom.title')}
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              {t('results.freedom.description')}
            </p>
          </div>
          
          <div className="relative max-w-4xl mx-auto">
            <div className="overflow-hidden rounded-3xl shadow-2xl">
              <div className="bg-white/10 backdrop-blur-sm p-8 sm:p-12 text-center border border-white/20 transition-all duration-500">
                <div className="flex flex-col items-center space-y-6">
                  <div className={`w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-r ${slides[currentSlide].gradient} rounded-full flex items-center justify-center text-white shadow-lg transition-all duration-500`}>
                    {slides[currentSlide].icon}
                  </div>
                  <h3 className={`text-2xl sm:text-3xl font-bold bg-gradient-to-r ${slides[currentSlide].gradient} bg-clip-text text-transparent transition-all duration-500`}>
                    {slides[currentSlide].title}
                  </h3>
                  <p className="text-base sm:text-lg text-gray-200 max-w-2xl leading-relaxed transition-all duration-500">
                    {slides[currentSlide].description}
                  </p>
                </div>
              </div>
            </div>
            
            {/* Тонкие кнопки навигации */}
            <button 
              onClick={prevSlide}
              className="absolute left-2 sm:left-4 top-1/2 transform -translate-y-1/2 w-8 h-8 sm:w-10 sm:h-10 bg-white/90 hover:bg-white rounded-full shadow-lg flex items-center justify-center text-gray-600 hover:text-gray-900 hover:shadow-xl transition-all duration-200 group"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 sm:w-5 sm:h-5 group-hover:scale-110 transition-transform">
                <path d="m15 18-6-6 6-6"></path>
              </svg>
            </button>
            <button 
              onClick={nextSlide}
              className="absolute right-2 sm:right-4 top-1/2 transform -translate-y-1/2 w-8 h-8 sm:w-10 sm:h-10 bg-white/90 hover:bg-white rounded-full shadow-lg flex items-center justify-center text-gray-600 hover:text-gray-900 hover:shadow-xl transition-all duration-200 group"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 sm:w-5 sm:h-5 group-hover:scale-110 transition-transform">
                <path d="m9 18 6-6-6-6"></path>
              </svg>
            </button>
          </div>
          
          {/* Индикаторы */}
          <div className="flex justify-center space-x-2 sm:space-x-3 mt-6 sm:mt-8">
            {slides.map((_, index) => (
              <button 
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all duration-200 ${
                  index === currentSlide 
                    ? `bg-gradient-to-r ${slides[currentSlide].gradient} shadow-lg` 
                    : 'bg-gray-400 hover:bg-gray-300'
                }`}
              />
            ))}
          </div>
          
          <div className="text-center mt-6">
            <p className="text-sm text-gray-400">
              {t('results.freedom.scroll_hint')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
